import defaultsDeep from "lodash/defaultsDeep";
/*
	_state.options should be an object that looks like: (shown with some default values)
	{
		metadata: {}, // metadata related to the operation that will be dispatched on confirmation and also passed to i18n translate function
		dialog: {
			contentClass: "app-confirmation-dialog",
			cardContainerClass: "app-confirmation-dialog__container",
		},
		header: {
			class: "app-confirmation-dialog__header",
			text: "message.AppConfirmationDialog_genericHeaderText",
		},
		body: {
			containerClass: "app-confirmation-dialog__body-container",
			contentClass: "app-confirmation-dialog__body-content",
			text: "message.AppConfirmationDialog_genericBodyText",
		},
		confirm: {
			action: "actionToDispatchOnConfirmation",
			buttonText: "message.AppConfirmationDialog_genericConfirmButtonText",
			class: "app-confirmation-dialog__confirm-button",
			close: true,
		},
		altConfirm: {
			action: "alternateActionToDispatchOnAltConfirmation",
			buttonText: "",
			class: "app-confirmation-dialog__alt-confirm-button"
		},
		cancel: {
			action: "actionToDispatchOnCancel",
			buttonText: "message.AppConfirmationDialog_genericCancelButtonText",
			class: "app-confirmation-dialog__cancel-button"
		}
	}
*/

function applyDefaultOptions( options = {} ) {
	return defaultsDeep( options, {
		metadata: {},
		dialog: {
			contentClass: "app-confirmation-dialog",
			cardContainerClass: "app-confirmation-dialog__container",
		},
		header: {
			class: "app-confirmation-dialog__header",
			text: "message.AppConfirmationDialog_genericHeaderText",
		},
		body: {
			containerClass: "app-confirmation-dialog__body-container",
			contentClass: "app-confirmation-dialog__body-content",
			text: "",
		},
		confirm: {
			action: "",
			buttonText: "message.AppConfirmationDialog_genericConfirmButtonText",
			class: "app-confirmation-dialog__confirm-button",
			close: true,
		},
		altConfirm: {
			action: "",
			buttonText: "",
			class: "app-confirmation-dialog__alt-confirm-button",
		},
		cancel: {
			action: "",
			buttonText: "message.AppConfirmationDialog_genericCancelButtonText",
			class: "app-confirmation-dialog__cancel-button",
		},
	} );
}

const _state = {
	isConfirmationDialogOpen: false,
	options: applyDefaultOptions( {} ),
};

const getters = {
	isConfirmationDialogOpen: state => state.isConfirmationDialogOpen,
	confirmationDialogOptions: state => state.options,
};

/**
 * Reactions are really just mutations that are called when an
 *   action invokes the store's `commit()` function. Separating them
 *   here for clarity. They are merged into mutations below.
 */
const reactions = {
};

const mutations = {
	...reactions,
	requestUserConfirmation( state, options = {} ) {
		state.options = applyDefaultOptions( options );
		state.isConfirmationDialogOpen = true;
	},
	openConfirmationDialog( state ) {
		state.isConfirmationDialogOpen = true;
	},
	closeConfirmationDialog( state ) {
		state.isConfirmationDialogOpen = false;
	},
	toggleConfirmationDialog( state, isOpen ) {
		state.isConfirmationDialogOpen = isOpen;
	},
	applyConfirmationOptions( state, options ) {
		state.options = options;
	},
};

const actions = {
};

export default {
	state: _state,
	getters,
	actions,
	mutations,
	namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/confirmationDialog/index.js